// extracted by mini-css-extract-plugin
module.exports = {"emptyNode":"JobFunctionForPcWithCustom_emptyNode__jI8SJ","highlightSpan":"JobFunctionForPcWithCustom_highlightSpan__a0zUh"};